import {useQuery} from '@tanstack/react-query'
import {getCategoryList} from '@/services/CategoryService/category'

// dropdowns/${type} returns { data: [{ id, en }] }; when no dropdownType we map to { categoryId, category } for consumers
export const useCategoryList = (dropdownType = '', isEnabled = true) => {
  const effectiveType = dropdownType || 'categories'
  const normalize = !dropdownType

  const query = useQuery({
    queryKey: ['categoryDropdown', effectiveType],
    queryFn: () => getCategoryList(effectiveType),
    enabled: !!effectiveType && isEnabled,
    initialData: {data: []},
  })

  const list = query?.data?.data ?? []
  const categoryListData = normalize
    ? list.map(item => ({ categoryId: item.id, category: item.en }))
    : list

  return {
    categoryListData,
    isLoading: query?.isLoading || false,
  }
}
